// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/home/runner/work/e-learning-fe/e-learning-fe/src/models/useStudent';
import model_2 from '/home/runner/work/e-learning-fe/e-learning-fe/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'useStudent', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
